<template>
  <vs-popup :title="currTabItem.label" :active.sync="showPopup" id="Popupboard-Container">
    <PopupBoardWrite v-if="showPopup && !readonly && type === 'write'" :boardId="boardId" :readonly="readonly"
                     :form-overwrite="formOverwrite"
                     @successCreate="successCreate" @movePage="(value) => movePage(value)" />
    <PopupBoardList v-else-if="showPopup" :boardId="boardId" :listTheme="currTabItem.listTheme"
                    :minWidth="currTabItem.minWidth" :readonly="readonly" @onClickNew="() => movePage('write')"/>
  </vs-popup>
</template>
<script>
import PopupBoardList from "./PopupBoardList.vue";
import PopupBoardWrite from "./PopupBoardWrite.vue";

import tabItems from "@/views/boards/tab/tab-items";

export default {
  components: {
    PopupBoardList,
    PopupBoardWrite,
  },
  props: {
    value: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    propsType: { type: String, default: "list" },
    boardId: { type: Number, default: 0 },
    formOverwrite: { type: Object, default: () => ({}) },
  },
  watch: {
    value(data) {
      this.type = this.propsType;
      this.showPopup = data;
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },
  computed: {
    currTabItem() {
      return tabItems[this.boardId];
    },
  },
  data() {
    return { showPopup: this.value, type: "list" };
  },
  methods: {
    successCreate() {
      this.$emit("successCreate");
    },
    movePage(type) {
      if (!this.readonly && type === "write") this.type = type;
      else this.type = type;
    },
  },
};
</script>

<style lang="scss" scoped>
#Popupboard-Container::v-deep {
  .vs-popup {
    width: 95%;
  }
}
</style>
